export default {
      id: "unit-linked-insurance-plans-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#unit-linked-insurance-plans",
      toString: function () {
        return this.url;
      }
    }